import Layout from '@/components/feature/Layout';
import { companyInfo } from '@/mocks/company';
import { products } from '@/mocks/products';
import { Link } from 'react-router-dom';

const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Máquina de Solda Geomembrana Manual',
  description: 'Máquinas de solda geomembrana manuais para pequenas áreas e acesso restrito.',
  url: 'https://maquinadesoldageomembrana.com.br/maquina-de-solda-geomembrana-manual',
  inLanguage: 'pt-BR',
};

export default function ManualPage() {
  const manuais = products.filter((p) => p.category === 'Cunha Quente');

  return (
    <Layout>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="w-full px-4 md:px-6 lg:px-10 pt-28 md:pt-32 pb-16 md:pb-24">
        <nav className="text-xs text-foreground-400 mb-6">
          <Link to="/" className="hover:text-primary-600 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line mx-1" />
          <Link to="/maquina-de-solda-de-geomembrana" className="hover:text-primary-600 cursor-pointer">Máquinas</Link>
          <i className="ri-arrow-right-s-line mx-1" />
          <span className="text-foreground-600">Manual</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12">
          <div className="lg:col-span-2">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight mb-6">
              Máquina de Solda Geomembrana Manual
            </h1>

            <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-4">
              <p>
                As <strong className="text-foreground-950">máquinas de solda geomembrana manuais</strong> operadas com cunha quente são operadas diretamente pelo técnico. Equipamentos como a <strong>BT800</strong> e <strong>BT1600</strong> são leves, econômicas e ideais para projetos de menor porte, locais de acesso restrito, reparos e treinamento de operadores.
              </p>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 uppercase mt-8 mb-3">Vantagens da Solda Manual</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  { icon: 'ri-wallet-line', title: 'Investimento Menor', desc: 'Equipamento mais acessível para empreiteiros iniciantes.' },
                  { icon: 'ri-ruler-line', title: 'Controle Direto', desc: 'Operador ajusta velocidade e pressão em tempo real.' },
                  { icon: 'ri-corner-up-left-line', title: 'Flexibilidade', desc: 'Cantos, áreas estreitas, tanques circulares e reparos.' },
                  { icon: 'ri-battery-2-charge-line', title: 'Portátil', desc: 'Leve e compacta. Ideal para transporte entre obras.' },
                ].map((item) => (
                  <div key={item.title} className="bg-background-100 rounded-xl border border-background-200/70 p-5">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                      <i className={`${item.icon} text-primary-500 text-lg`} />
                    </div>
                    <h3 className="text-sm font-bold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-foreground-500 text-xs">{item.desc}</p>
                  </div>
                ))}
              </div>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 uppercase mt-8 mb-3">Quando Usar Manual</h2>
              <ul className="space-y-2">
                <li className="flex items-start gap-2"><i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" /><span><strong>Piscicultura</strong> — tanques rasos, formas irregulares, acesso estreito.</span></li>
                <li className="flex items-start gap-2"><i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" /><span><strong>Agricultura</strong> — lagoas pequenas, locais com solo irregular.</span></li>
                <li className="flex items-start gap-2"><i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" /><span><strong>Reparos</strong> — soldas de reparo e ajustes em campo.</span></li>
                <li className="flex items-start gap-2"><i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" /><span><strong>Treinamento</strong> — aprendizado prático antes de operar automática.</span></li>
              </ul>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 uppercase mt-8 mb-3">Diferença Entre Potências</h2>
              <p>
                A <strong>BT800</strong> com 800W é suficiente para geomembranas de 0,5 a 2,0 mm em PEAD. A <strong>BT1600</strong> com 1600W atinge maiores temperaturas, adequada para espessuras de 1,0 a 3,0 mm e climas mais frios. A <strong>CX300</strong> com 1400W é uma opção intermediária e econômica.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              <Link to="/modelos-de-maquinas" className="text-sm text-primary-600 hover:text-primary-700 font-medium bg-primary-50 px-3 py-1.5 rounded-full cursor-pointer">Ver Comparativo Completo</Link>
              <Link to="/maquina-de-solda-geomembrana-automatica" className="text-sm text-primary-600 hover:text-primary-700 font-medium bg-primary-50 px-3 py-1.5 rounded-full cursor-pointer">Ver Modelos Automáticos</Link>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-primary-50 rounded-2xl border border-primary-200/70 p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950 uppercase mb-3">Solicitar Orçamento</h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-5">Indicamos o modelo ideal para seu projeto e orçamento.</p>
              <a href={whatsappUrl} target="_blank" rel="nofollow noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide">
                <i className="ri-whatsapp-line" /> Falar no WhatsApp
              </a>
            </div>

            <div className="bg-white rounded-2xl border border-background-200/70 p-5">
              <h4 className="font-heading text-sm font-bold text-foreground-900 uppercase mb-3">Modelos Manuais</h4>
              <div className="space-y-3">
                {manuais.slice(0, 4).map((p) => (
                  <div key={p.id} className="flex items-start gap-3 py-3 border-b border-background-200/40 last:border-0">
                    <img alt={p.name} className="w-16 h-16 object-contain rounded-lg bg-background-100 flex-shrink-0" src={p.image} />
                    <div>
                      <p className="font-bold text-sm text-foreground-900">{p.name}</p>
                      <p className="text-foreground-400 text-xs">{p.specs.potencia} · {p.specs.velocidade}</p>
                      <p className="text-primary-600 text-xs font-bold mt-0.5">{p.specs.material}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}